import { keyframes } from '@emotion/core'
import styled from '@themes/theme'
import { ShowAni, TxtLimit } from '@styles/base.style'

export const topNoticeY = 42
export const topNoticeH = `${topNoticeY}px`

export const noticeBgAni = keyframes`
  0% {
    background-position: right;
  }
  80%, 100% {
    background-position: left;
  }
`

export const TopNoticeWrap = styled.div`
  position: relative;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  height: ${topNoticeH};
  margin-bottom: 1px;
  padding: 0 9px 0 14px;
  background: linear-gradient(to left, #2C3340 25%, #303745 35%, #3C4559 50%, #303745 65%, #2C3340 75%);
  background-size: 400%;
  animation: ${noticeBgAni} 3s infinite cubic-bezier(.65,0,.46,.98);
  .notice-ico {
    position: relative;
    display: inline-block;
    width: 30px;
    height: 21px;
    line-height: 240%;
    margin-right: 9px;
    text-align: center;
    border-radius: 50px;
    background: linear-gradient(98deg, #B1FF16, #1FD8D8, #B1FF16);
    background-size: 720%;
    animation: ${noticeBgAni} 4s infinite linear;
    svg {
      width: 14px;
      height: auto;
      .fill {
        fill: ${props => props.theme.color.mainBg};
      }
    }
    .am-badge {
      top: -7px;
      right: initial;
      left: 100%;
      transform: translateX(-50%);
      .am-badge-text {
        z-index: 0;
        min-width: 17px;
        width: auto;
        height: 17px;
        color: ${props => props.theme.color.modalTxt};
        font-size: ${props => props.theme.font.small};
        background: ${props => props.theme.color.themeTxt};
        border: 2px solid ${props => props.theme.color.subColor};
      }
    }
  }
  .notice-tit {
    flex: 1;
    transform: translateY(2px);
    overflow: hidden;
    .tit {
      width: 100%;
      ${TxtLimit};
      font-weight: ${props => props.theme.fontW.medium};
    }
  }

  &.header-notice {
    display: none;
    left: 2px;
    width: auto;
    height: 100%;
    line-height: 400%;
    margin: 0;
    padding: 0;
    background: none;
    .am-badge {
      .am-badge-text {
        border-color: ${props => props.theme.color.mainBg};
      }
    }
    .notice-tit {
      display: none;
    }
    &.show {
      opacity: 0;
      display: inline-block;
      animation: ${ShowAni} 1 .1s .3s forwards; /* 다른 페이지에서 스크롤 후 매치업 진입 시 순간적으로 보여졌다 사라지는 현상 제어하기 위함 */
    }
  }
`
